/** C-03 엑셀 업로드 화면의 비식별 정적 데이터입니다. */
export const legacyExcelHistory = Array.from({ length: 30 }, (_, index) => ({
  no: index + 1,
  uploadedAt: `2026-08-${String(19 - (index % 18)).padStart(2, '0')} 10:${String(index).padStart(2, '0')}`,
  manager: '담당자 A',
  success: 8 + (index % 7),
  skipped: index % 3,
}))

export const legacyExcelPreviewRows = [
  ['C-MOCK-001', '고객 1', '아기 1', '010-0000-0001', '데모지점'],
  ['C-MOCK-002', '고객 2', '아기 2', '010-0000-0002', '데모지점'],
]

/** C-03 방문동기 명칭 확인 하위 화면의 비식별 선택값입니다. */
const mockOptions = (prefix: string, count: number) => Array.from({ length: count }, (_, index) => `${prefix} ${String(index + 1).padStart(3, '0')}`)

export const legacyExcelMotivationOptions = {
  group: mockOptions('Mock 그룹', 14),
  visitPath: mockOptions('Mock 유입경로', 533),
  hospital: mockOptions('Mock 산부인과', 232),
  postpartum: mockOptions('Mock 조리원', 117),
}
